var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_31394)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_31394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.560181 -1.55979H18.5602V17.5605H-0.560181V-1.55979Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_31394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.80444 6.30762V2.08744C1.80444 1.34962 2.40266 0.751517 3.14059 0.751517H14.8594C15.5974 0.751517 16.1956 1.34962 16.1956 2.08744V6.30762",
    stroke: "black",
    strokeWidth: 1.12033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3058 14.1885H0.694035C0.310657 14.1885 -0.00012207 13.8777 -0.00012207 13.4944V9.23773C-0.00012207 8.85439 0.310657 8.54361 0.694035 8.54361H17.3058C17.6891 8.54361 17.9999 8.85439 17.9999 9.23773V13.4944C17.9999 13.8777 17.6891 14.1885 17.3058 14.1885Z",
    stroke: "black",
    strokeWidth: 1.12033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0666 8.54395V7.66213C17.0666 6.91438 16.4603 6.30817 15.7124 6.30817H2.28735C1.53945 6.30817 0.933167 6.91438 0.933167 7.66213V8.54395",
    stroke: "black",
    strokeWidth: 1.12033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36751 6.30762C7.74954 6.30762 8.05924 5.99796 8.05924 5.61596V4.76346C8.05924 4.3815 7.74954 4.07184 7.36751 4.07184H4.35949C3.97742 4.07184 3.66772 4.3815 3.66772 4.76346V5.61596C3.66772 5.99796 3.97742 6.30762 4.35949 6.30762",
    stroke: "black",
    strokeWidth: 1.12033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6404 6.30762C14.0224 6.30762 14.3321 5.99796 14.3321 5.61596V4.76346C14.3321 4.3815 14.0224 4.07184 13.6404 4.07184H10.6324C10.2503 4.07184 9.94058 4.3815 9.94058 4.76346V5.61596C9.94058 5.99796 10.2503 6.30762 10.6324 6.30762",
    stroke: "black",
    strokeWidth: 1.12033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19208 14.1884V15.25",
    stroke: "black",
    strokeWidth: 1.12033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8077 14.1884V15.25",
    stroke: "black",
    strokeWidth: 1.12033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_31394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14.4983,
    fill: "white",
    transform: "translate(0 0.750977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedBlack);
export default __webpack_public_path__ + "static/media/bed_black.2c22ea6c56dcb3526903f502a9b34144.svg";
export { ForwardRef as ReactComponent };